export default __webpack_public_path__ + "static/media/1930.7ac05afa.png";